/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsRollback } from "../../funcs/llmPromptsRollback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RollbackPromptRequest$inboundSchema,
};

export const tool$llmPromptsRollback: ToolDefinition<typeof args> = {
  name: "llm-prompts-rollback",
  description: `Rollback to a version

Sets the active version of a prompt to a previous version. This does not delete newer versions — it only changes which version is active.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsRollback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
